export const MINIMUM_ITEMS_TO_FIX_BUTTON_WRAPPER = 5;
export const MINIMUM_ITEMS_TO_SHOW_SEARCH = 9;
